import API_BASE_URL from '../api';

const TOKEN_KEY = 'meb_admin_token';

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

async function adminFetch(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const token = getAdminToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE_URL}/admin${path}`, {
    ...options,
    headers,
  });

  let body = null;
  const text = await response.text();
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = { error: text || 'Unexpected response' };
  }

  if (!response.ok) {
    const err = new Error((body && body.error) || `Request failed (${response.status})`);
    err.status = response.status;
    err.errors = body && body.errors;
    err.warnings = body && body.warnings;
    throw err;
  }
  return body;
}

export async function adminLogin(password) {
  const data = await adminFetch('/login', {
    method: 'POST',
    body: JSON.stringify({ password }),
  });
  setAdminToken(data.token);
  return data;
}

export async function adminLogout() {
  try {
    await adminFetch('/logout', { method: 'POST' });
  } finally {
    setAdminToken('');
  }
}

export async function adminCheckSession() {
  return adminFetch('/session');
}

export async function listPrograms() {
  return adminFetch('/programs');
}

export async function getProgram(id) {
  return adminFetch(`/programs/${encodeURIComponent(id)}`);
}

export async function createProgram(program) {
  return adminFetch('/programs', {
    method: 'POST',
    body: JSON.stringify(program),
  });
}

export async function updateProgram(id, program) {
  return adminFetch(`/programs/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(program),
  });
}

export async function deleteProgram(id) {
  return adminFetch(`/programs/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

export async function publishProgram(id) {
  return adminFetch(`/programs/${encodeURIComponent(id)}/publish`, {
    method: 'POST',
  });
}

export async function getCategories() {
  return adminFetch('/categories');
}

export async function previewProgram(program, occurrenceId) {
  return adminFetch('/preview', {
    method: 'POST',
    body: JSON.stringify({ program, occurrenceId }),
  });
}
